<template>
  <div class="home">
    <VueTitle title="Sheldon Zhang"></VueTitle>
    <div class="lg:px-20 px-8">
      <section class="mt-44">
        <h1 class="baffle-animation font-mono text-3xl">Hey there!</h1>
        <h2 class="baffle-animation font-mono text-xl mt-2">I am Sheldon Zhang,</h2>

        <p id="description" class="font-mono mt-4 max-w-xl">
          Currently a Master student in <span class=" font-bold">Data Science</span> at Stevens Institute of Technology in Hoboken, New Jersey. I am proficient at using Python to <span class=" font-bold">analyze data</span> as well as utilizing <span class=" font-bold">machine learning algorithm</span> to establish model and inform better decision making. 
        </p>

        <div class="mt-16 flex flex-col space-y-3">
          <router-link to="/projects" class="underline font-mono text-blue-400"
            >Check the projects I have been working on</router-link
          >
          <router-link to="/resume" class="underline font-mono text-blue-400"
            >Get a copy of my resume</router-link
          >
        </div>
      </section>

      <section class="w-full mt-72">
        <div class="w-full flex-col lg:flex-row flex items-end">
          <div>
            <h1 class="lg:hidden mb-8 font-mono text-4xl">My Skills</h1>
            <p class="w-full lg:w-4/5">
              I have experience using Python package such as pandas, numpy, matplotlib, statsmodels and scipy, scikit-learn. I also have experience using data modeling tools such as  postgreSQL and Apache Cassandra. I have been expose to R and packages like Tidyverse and ggplot2 and big data tool like AWS, Spark and Tableau.
            </p>
          </div>
          <div class="relative">
            <h1
              class="hidden lg:block lg:absolute -top-14 -left-28 font-mono text-4xl lg:text-8xl"
            >
              My Skills
            </h1>
            <img
              class="mt-6 lg:mt-0 w-full"
              src="../assets/photos/IMG_2808.jpg"
              alt=""
            />
          </div>
        </div>
      </section>

       <section class="w-full mt-20 lg:mt-48
       flex-col lg:flex-row-reverse  flex items-end">
          <div class=" lg:ml-20">

          
            <p class="w-full lg:w-4/5">
              Besides work and school, I enjoy traveling, especially air travel. Being on an airplane brings me excitement and I like to explore different things. I am well-travelled in the state, my favorite places in the US is YellowStone National Park and Grand Teton National Park in Wyoming. I also consider myself tech savvy because I am always so pumped up when new tech products releases.
            </p>
            </div>
          <div>
            <img
              class="mt-6 lg:mt-0 w-full"
              src="../assets/photos/IMG_4593.jpg"
              alt=""
            />
          </div>
      </section>

     
    </div>

     <section class="  mt-14">
        <div class=" flex font-mono text-gray-500  h-28 justify-around border-t border-b">
          <a href="https://github.com/zzy98y" class=" w-full cursor-pointer hover:bg-gray-100 flex items-center justify-center border-r">
            <span class=" uppercase">Github</span>
        </a>
        <a href="https://medium.com/@zzy98y" class=" w-full cursor-pointer hover:bg-gray-100 flex items-center justify-center border-r">
            <span class=" uppercase">MEDIUM</span>
        </a>
        <a href="https://open.spotify.com/user/1299024796?si=Fhb8DQnSTzStOJFEa0VMkQ" class=" w-full cursor-pointer hover:bg-gray-100 flex items-center justify-center border-r">
            <span class=" uppercase">Spotify</span>
        </a>
        <a href="https://www.linkedin.com/in/sheldon-zhang-012198" class=" w-full cursor-pointer hover:bg-gray-100 flex items-center justify-center border-r">
            <span class=" uppercase">Linkedin</span>
        </a>
        </div>
        
      </section>
  </div>
</template>

<script>
// @ is an alias to /src
import VueTitle from "../components/VueTitle.vue";
import baffle from 'baffle';
export default {
  name: "Home",
  components: {
    VueTitle,
  },
  methods: {
    coolStaffs() {
      let b = baffle('.baffle-animation')

      b.start()

      b.reveal(1000)
    }
  },
  mounted() {
    this.coolStaffs()
  }
};
</script>

<style>
.top-section-link {
  --tw-text-opacity: 1;
  color: rgba(147, 197, 253, var(--tw-text-opacity));
}
</style>